import { useEffect, useRef } from "react";
import useSession from "Utils/Hooks/useSession";
import { useHistory } from "react-router-dom";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useMode from "Utils/Hooks/useMode";


/* const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
]; */

const AppLogout = ({ children }) => {
    const { session, invalidateSession } = useSession();
    const vipApi = useVipApiFetcher();
    const mode = useMode();
    let sessionExpiry = new Date(session.expires);
    const timeOutRef = useRef(null);
    let history = useHistory();
    const expiration = useRef(sessionExpiry - new Date());
    // let timer;
    useEffect(() => {
        expiration.current = new Date(session.expires) - new Date();
        timeOutRef.current = setTimeout(
            () => logoutAction(),
            expiration.current
        );
        return () => clearTimeout(timeOutRef.current);
        /*         Object.values(events).forEach((item) => {
                    window.addEventListener(item, () => {
                        resetTimer();
                        handleTimer();
                    });
                }); */
    }, [session]);

    // const resetTimer = () => {
    //     if (window.location.pathname !== '/logout' && timer) clearTimeout(timer);
    // };

    // const handleTimer = () => {
    //     if (window.location.pathname !== '/logout') {
    //         timer = setTimeout(() => {
    //             resetTimer();
    //             Object.values(events).forEach((item) => {
    //                 window.removeEventListener(item, resetTimer);
    //             });
    //             logoutAction();
    //         }, 100000);
    //     }

    // };

    const logoutAction = async () => {
      await NotifyLogout();
    };

  async function NotifyLogout() {
    if (!session || (session && !session.transactionSucceeded)) {
      vipApi
        .fetch("/api/usertracking/cancelflow", "POST", {
          transactionStage: mode === "withdraw" ? "Withdrawal" : "Deposit",
        })
        .then((response) => {
          if (response.ok) {
            invalidateSession();
            history.push("/logout");
          } else {
            if (response.status === 500) {
              console.error(response.statusText);
              history.push({
                pathname: "/error",
              });
            } else if (response.status === 401) {
              console.error(response.statusText);
              history.push({
                pathname: "/expired",
              });
            } else {
              response.json().then((data) => {
                console.error(data);
                onError(data);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          history.push({
            pathname: "/error",
          });
        });
    } else {
      invalidateSession();
      history.push("/logout");
    }
  }

    function onError(response) {
        history.push({
            pathname: '/error',
            state: {
                isError: true,
                showButton: true,
                title: "Request Failed. Please Try Again",
                message: response.patronErrorMessage ?? "Your Cancel Request Failed. Please Try Again",
                allowRetry: false
            }
        });
    }
    return children;
};

export default AppLogout;

